import PropTypes from 'prop-types';
import { ActionsMenu } from '@evertrue/et-components';

const ListIndexActions = ({
  listType = 'static',
  enableAllActions = false,
  openCreateModal = () => {},
  openBulkDeleteModal = () => {},
  folderCardRef = { current: {} },
  anyListSelected = false,
}) => {
  const options = [
    {
      id: 1,
      icon: 'add',
      label: 'Create Folder',
      onClick: () => folderCardRef.current?.openCreateFolderModal(),
    },
  ];

  if (listType === 'static') {
    options.unshift({
      id: 2,
      icon: 'add',
      label: listType === 'static' ? 'Create List' : 'Create Saved Search',
      onClick: openCreateModal,
    });
  }

  if (anyListSelected) {
    options.push({
      id: 3,
      icon: 'folder',
      iconKit: 'gt2',
      label: listType === 'static' ? 'Add List to Folder' : 'Add Saved Search to Folder',
      onClick: () => folderCardRef.current?.openAddListSavedSearchesToFolderModal(),
    });
    if (enableAllActions) {
      options.push({
        id: 4,
        icon: 'trash',
        label: listType === 'static' ? 'Delete Selected Lists' : 'Delete Selected Saved Searches',
        onClick: () => openBulkDeleteModal(),
      });
    }
  }
  return <ActionsMenu options={options} />;
};

ListIndexActions.propTypes = {
  listType: PropTypes.string,
  enableAllActions: PropTypes.bool,
  openCreateModal: PropTypes.func,
  openBulkDeleteModal: PropTypes.func,
  folderCardRef: PropTypes.shape({
    current: PropTypes.object,
  }),
  anyListSelected: PropTypes.bool,
};

export default ListIndexActions;
